import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface WaiterData {
  id: string
  name: string
  role: 'waiter' | 'kitchen'
  tenant_id: string
  is_active?: boolean
}

interface WaiterState {
  waiter: WaiterData | null
  setWaiter: (data: WaiterData) => void
  clearWaiter: () => void
}

export const useWaiterStore = create<WaiterState>()(
  persist(
    (set) => ({
      waiter: null,

      setWaiter: (data) => set({ waiter: data }),

      clearWaiter: () => set({ waiter: null }),
    }),
    {
      name: '@usecomanda:waiter_data',
    },
  ),
)
